var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTleActive = function SvgIconTleActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.25
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#24C3CF",
    stroke: "#24C3CF",
    d: "M2.855.903C4.903.634 6.952.5 9 .5c2.048 0 4.097.134 6.145.403 1.92.253 3.355 1.889 3.355 3.825v9.406c0 1.866-1.336 3.465-3.173 3.796-2.109.38-4.218.57-6.327.57-2.11 0-4.218-.19-6.327-.57C.836 17.599-.5 16-.5 14.134V4.728C-.5 2.792.935 1.156 2.855.903z",
    transform: "translate(-176 -322) translate(176 322) translate(5 4) rotate(90 9 9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.536 5.797L5.464 5.797",
    transform: "translate(-176 -322) translate(176 322) translate(5 4)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.536 9.661L5.464 9.661",
    opacity: 0.397,
    transform: "translate(-176 -322) translate(176 322) translate(5 4)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 13.525L5.464 13.525",
    transform: "translate(-176 -322) translate(176 322) translate(5 4)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTleActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-tle-active.1ede0d59cc9772a74381d5574d84e924.svg";